import { useDimension } from 'hooks/queryParams/useDimension';

/**
 * @deprecated - use useDimension
 */
const dimensionSelector = useDimension.createSelector();

export default dimensionSelector;
